// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
function t_toString(value) {
  if (value.TAG === /* Product */0) {
    return "P" + value._0.id;
  } else {
    return "P" + value._0;
  }
}
function t_fromString(string) {
  if (string.startsWith("P")) {
    return {
      TAG: /* ProductId */1,
      _0: string.replace(/^P/, "")
    };
  }
}
function toString(array) {
  return Belt_Array.map(array, t_toString).join(",");
}
function fromString(string) {
  return Belt_Array.keepMap(Belt_Array.map(string.split(","), t_fromString), function (a) {
    return a;
  });
}
function contains(array, value) {
  return Belt_Array.some(array, function (v) {
    return t_toString(v) === t_toString(value);
  });
}
var $$Array = {
  toString: toString,
  fromString: fromString,
  contains: contains
};
var Value = {
  t_toString: t_toString,
  t_fromString: t_fromString,
  $$Array: $$Array,
  toString: t_toString,
  fromString: t_fromString
};
var empty_value = [];
function empty_add(param) {
  return Promise.resolve(undefined);
}
function empty_remove(param) {
  return Promise.resolve(undefined);
}
function empty_isAdded(param) {
  return Promise.resolve(false);
}
var empty = {
  value: empty_value,
  enabled: false,
  add: empty_add,
  remove: empty_remove,
  isAdded: empty_isAdded,
  count: 0
};
var emptyGroup = {
  history: empty,
  favorites: empty
};
export { Value, empty, emptyGroup };
/* No side effect */